import { createI18n } from 'next-international'
import au from './au'
import de from './de'
import en from './en'
import es from './es'
import fr from './fr'
import it from './it'
import nl from './nl'
import uk from './uk'
import us from './us'

/**
 * Enable i18n for next.js
 */
export const { useChangeLocale, useCurrentLocale, useI18n, useScopedI18n, I18nProvider, getLocaleProps } = createI18n({
  en: () => import('./en'),
  es: () => import('./es'),
  de: () => import('./de'),
  nl: () => import('./nl'),
  it: () => import('./it'),
  uk: () => import('./uk'),
  au: () => import('./au'),
  us: () => import('./us'),
  fr: () => import('./fr')
})

export const locales = {
  en,
  es,
  de,
  nl,
  it,
  uk,
  au,
  us,
  fr
} as const
